import ApiEndpoint, { ApiResponse } from 'network/ApiEndpoint'
import { mapGroupResponse } from './mapGroupsResponse'

export const getEventGroups = async ({
  eventSlug,
  slug
}: {
  eventSlug: string
  slug: string
}) => {
  try {
    const resultResponse: ApiResponse = await ApiEndpoint.call({
      path: `events/event/${eventSlug}/groups`,
      params: {
        company: slug
      }
    })
    const responseData = await resultResponse
    const map = mapGroupResponse(responseData.data)
    return { data: map, totalCount: responseData.totalCount }
  } catch (e: any) {
    // @ts-ignore
    throw new Error(e.message)
  }
}
